import Cgl from 'Cgl';
import Vue from 'vue';
import Base from './Base';

const CellMainContent = {
    name: "CellMainContent",
    extends: Base,
    props: {
        colName: {
            type: String,
            default: ""
        }
    },
    computed: {
        /**
         * @author chen yu
         * @date 22/01/2021 00:01:42
         * @type {PositionInfo}
         * @description 位置信息
         */
        PositionInfo() {
            return this.layoutConfig.GetPositionInfo();
        },
        /**
         * @author chen yu
         * @date 22/01/2021 00:01:00
         * @type {number}
         * @description 当前表单项所占列数
         */
        Columns() {
            return this.PositionInfo?.Columns || 0;
        }
    },
    methods: {
        /**
         * @author chen yu
         * @date 22/01/2021 00:01:00
         * @param {Function} h
         * @returns {import('vue/types/umd').VNode} 
         * @description 渲染右侧插槽
         */
        RenderRightSlot(h) {

            const _rightSlot = this.$scopedSlots[`layout-${this.colName}-right`];

            return _rightSlot
                ? (
                    <div class="cmn-grid-cell-form-content-right" style={{
                        gridColumnStart: this.Columns - 5 - 2 + 2, gridColumnEnd: this.Columns - 5 + 2
                    }}>
                        {_rightSlot(this.layoutConfig)}
                    </div>
                )
                : null;
        },
        RenderControlSlot() {

            const _controlSlot = this.$scopedSlots[`layout-${this.colName}`];

            return _controlSlot ? _controlSlot : null;
        }
    },
    render(h) {

        let _rightSlot = this.RenderRightSlot(h);
        let _controlSlot = this.RenderControlSlot(h);

        const cell = this.$scopedSlots.cell(this.layoutConfig);

        // 用来支持表单验证
        Object.keys(this.$listeners).forEach(eventName => {
            cell[0].componentOptions.listeners[eventName] = [this.$listeners[eventName]].concat(cell[0].componentOptions.listeners[eventName] || []);
        });
        
        return (<div class="cmn-grid-cell-form-main-content" style={{
            gridTemplateColumns: `repeat(${this.Columns - 5 + 1}, 1fr)`
        }}>
            <div class="cmn-grid-cell-form-content-left" style={{
                gridColumnStart: 1, gridColumnEnd: this.Columns - 5 - 2 + 2  + (_rightSlot ? 0 : 5)
            }}>
                {_controlSlot ? _controlSlot(this.layoutConfig) : cell}
            </div>
            {_rightSlot}
        </div>);
    },
};

export default {
    name: "Cell",
    extends: Base,
    computed: {
        /**
         * @author chen yu
         * @date 22/01/2021 00:01:34
         * @type {ColInfo}
         * @description 字段信息
         */
        ColInfo() {
            return this.layoutConfig.ColInfo;
        },
        /**
         * @author chen yu
         * @date 22/01/2021 00:01:55
         * @type {string} 
         * @description todo this.ColInfo可能不存在
         */
        ColName() {
            return this.ColInfo.ColName || "";

            // return _colName ? Cgl.Str.HumpToHLine(_colName).replaceAll('-', '_') : _colName;
        },
        /**
         * @author chen yu
         * @date 22/01/2021 00:01:55
         * @type {string} 
         * @description
         */
        IsShow() {
            const _colInfo = this.ColInfo;
            return _colInfo?.ControlCfg?.IsShow || "1";
        },
        /**
         * @author chen yu
         * @date 22/01/2021 00:01:11
         * @type {string}
         * @description 字段描述
         */
        Title() {
            const _colInfo = this.ColInfo;
            return _colInfo?.ControlCfg?.ColTitle || "";
        },
        /**
         * @author chen yu
         * @date 22/01/2021 00:01:42
         * @type {PositionInfo}
         * @description 位置信息
         */
        PositionInfo() {
            return this.layoutConfig.GetPositionInfo();
        },
        /**
         * @author chen yu
         * @date 22/01/2021 00:01:00
         * @type {number}
         * @description 当前表单项所占列数
         */
        Columns() {
            return this.PositionInfo?.Columns || 0;
        },
        /**
         * @author chen yu
         * @date 22/01/2021 00:01:39
         * @type {number}
         * @description 当前表单项所占行数
         */
        Rows() {
            return this.PositionInfo?.Rows || 0;
        },
        ControlCfg() {
            return {
                ...this.layoutConfig.ColInfo,
                ...this.layoutConfig.ColInfo.ControlCfg
            };
        },
        IsHideDesc() {
            return this.ControlCfg?.IsShowColDesc === '0';
        }
    },
    methods: {
        /**
         * @author chen yu
         * @date 22/01/2021 00:01:09
         * @param {Function} h
         * @returns {import('vue/types/umd').VNode} 
         * @description 渲染左侧插槽
         */
        RenderLeftSlot(h) {
            return this.Title;
            // return this.Title || this.ColName;
        },
        /**
         * @author chen yu
         * @date 22/01/2021 00:01:09
         * @param {Function} h
         * @returns {import('vue/types/umd').VNode} 
         * @description 渲染表单项
         */
        RenderFormItem(h) {
            
            //验证规则
            let _rules = [];
            //是否必填
            if(this.layoutConfig.ColInfo?.IsRequired === '1') {

                let _control = Vue.component(
                    `CgEdit${this.layoutConfig.ColInfo?.ColControlName}`
                );

                if(!_control?.options?.IsSetValByKey) {
                    _rules.push({ required: true, message: `请录入${this.RenderLeftSlot()}！`, trigger: 'change' });
                }
            }

            //长度判断
            if(this.ControlCfg?.MaxInputLength && this.ControlCfg?.MinInputLength) {
                _rules.push({ 
                    min: this.ControlCfg?.MinInputLength, max: this.ControlCfg?.MaxInputLength, 
                    message: `${this.RenderLeftSlot()}的长度在${this.ControlCfg?.MinInputLength}和${this.ControlCfg?.MaxInputLength}之间`, trigger: 'change' 
                });
            }
            else if(this.ControlCfg?.MaxInputLength) {
                _rules.push({ 
                    max: this.ControlCfg?.MaxInputLength, 
                    message: `${this.RenderLeftSlot()}的长度不能大于${this.ControlCfg?.MaxInputLength}`, trigger: 'change' 
                });
            }
            else if(this.ControlCfg?.MinInputLength) {
                _rules.push({ 
                    min: this.ControlCfg?.MinInputLength, 
                    message: `${this.RenderLeftSlot()}的长度不能小于${this.ControlCfg?.MinInputLength}`, trigger: 'change' 
                });
            }
            
            //正则表达式
            if(this.ControlCfg && this.ControlCfg.RegexContent){

                let _regex = this.ControlCfg.RegexContent;

                if (_regex[0] == "/") { _regex = _regex.substr(1, _regex.length - 2); };

                _rules.push({
                    pattern: new RegExp(_regex),
                    message: this.ControlCfg.RegexErrorMsg || `${this.RenderLeftSlot()}录入的数据不合法！`, 
                    trigger: 'change'
                });
            }

            const _formItemProps = {
                prop: this.ColName,
                // required: this.layoutConfig.ColInfo?.IsRequired === '1',
                rules: _rules,
            };

            if (!this.IsHideDesc) {
                _formItemProps.label = this.RenderLeftSlot;
                _formItemProps.labelCol = { style: { gridColumnStart: 1, gridColumnEnd: 5, whiteSpace: "normal" } },
                _formItemProps.wrapperCol = { style: { gridColumnStart: 5, gridColumnEnd: this.Columns + 1 } }
            } else {
                _formItemProps.wrapperCol = { style: { gridColumnStart: 1, gridColumnEnd: this.Columns + 1 } }
            }

            return [
                this.RenderTopSlot(h),
                (
                    <div class="cmn-grid-cell-form-content-main" style={{
                        gridColumnStart: 1, gridColumnEnd: this.Columns + 1
                    }}>
                        <a-form-model-item
                            key={this.layoutConfig.ID}
                            props={_formItemProps}
                            class="cmn-grid-cell-form-item"
                            style={{ gridTemplateColumns: `repeat(${this.Columns}, 1fr)` }}
                        >
                            <CellMainContent
                                props={{
                                    config: this.config,
                                    layoutConfig: this.layoutConfig,
                                    colName: this.ColName
                                }}
                                scopedSlots={this.$scopedSlots}
                            />
                        </a-form-model-item>
                    </div>
                )
            ];

        },
        /**
         * @author chen yu
         * @date 22/01/2021 00:01:36
         * @param {Function} h
         * @returns {import('vue/types/umd').VNode} 
         * @description 渲染上面的插槽
         */
        RenderTopSlot(h) {

            const _topSlot = this.$scopedSlots[`layout-${this.ColName}-top`];

            return _topSlot
                ? (
                    <div class="cmn-grid-cell-form-content-top" style={{
                        gridColumnStart: 5, gridColumnEnd: this.Columns + 1
                    }}>
                        {_topSlot(this.layoutConfig)}
                    </div>
                )
                : null;
        }
    },
    render(h) {
        
        return (
            <div class="cmn-grid-cell" style={{
                display: this.ControlCfg.IsShow !== '0' ? "block" : "none",
                marginBottom: "24px",
                minHeight: this.Rows * 40 + 24 * (this.Rows - 1) + 'px',
                pointerEvents: this.config.isCustomLayoutMode ? "none" : ""
            }}>
                <div class="cmn-grid-cell-form-item-content" style={{
                    gridTemplateColumns: `repeat(${this.Columns}, 1fr)`
                }}>
                    {this.RenderFormItem(h)}
                </div>
            </div>
        );
    }
};
